import {newSpecPage} from '@stencil/core/testing';
import {SallaSlider} from '../salla-slider';

describe('salla-slider', () => {
  it("should build", () => {
    expect(new SallaSlider()).toBeTruthy();
  })

  describe('rendering', () => {

    let page;

    beforeEach(async () => {
      page = await newSpecPage({
        components: [SallaSlider],
        html: '<salla-slider></salla-slider>'
      });
    });

    it.skip('should be able to render component', async () => {
      // await page.waitForChanges();
      let component = page.doc.querySelector('salla-slider');
      expect(component).toBeDefined();
    });
  });
});
